module.exports = __webpack_public_path__ + "img/logo-ucd@2x.png";